import { getCookie, getCookies, setCookie } from '../util/util2';
import { cookieLog } from '../service';
import { getCountry, getLang, getPlayncDomain, getSeviceEnv } from '../util/util';


export default abstract class AbsGlobalCookie{
  APPLY_COOKIE: string;
  URL_COOKIE_POLICY: string;
  URL_COOKIE_POLICY_LAYER_OPEN: string;
  getCookieNamesToDelete!: () => string[];

  abstract cookieNamesToDelete: ReturnType<InstanceType<typeof AbsGlobalCookie>['_getNotAppiedCookieNames']>;

  constructor(){
    this.APPLY_COOKIE = 'applyCookie';
    // this.URL_COOKIE_POLICY = `${getPlayncDomain()}/policy/cookiepolicy?locale=${getLang({onlyUsingLanguageArr: ['ar', 'en', 'id', 'ja', 'ko', 'th', 'zh', 'ru'], defaultLang: 'en'})}-${getCountry()}`;
    this.URL_COOKIE_POLICY = `${getPlayncDomain()}/policy/cookiepolicy`;
    this.URL_COOKIE_POLICY_LAYER_OPEN = `${this.URL_COOKIE_POLICY}?showLayer=true`;
    // this.URL_COOKIE_POLICY_LAYER_OPEN = `${this.URL_COOKIE_POLICY}?showLayer=true&locale=${getLang({onlyUsingLanguageArr: ['ar', 'en', 'id', 'ja', 'ko', 'th', 'zh', 'ru'], defaultLang: 'en'})}-${getCountry()}`;

  }

  // 필수쿠키만 저장하기
  _applyCookieOnlyRequired(curOptCookieListVer: string, targetHref: string): void{
    this._applyCookie(['NECESSARY'], curOptCookieListVer, targetHref);
  }

  // 모든타입의 쿠키 저장하기
  _applyCookieAll(curOptCookieListVer: string, targetHref: string): void{
    let applyCookieTypeAll: ApplyCookieTypeAll = ['NECESSARY', 'FUNCTIONAL', 'PERFORMANCE', 'ADVERTISING'];
    this._applyCookie(applyCookieTypeAll, curOptCookieListVer, targetHref);
  }


  // 쿠키허용상태 저장하기 클릭
  _applyCookie(applyCookieTypeArr: ApplyCookieTypeArr, optCookieListVer: string, targetHref: string): boolean{
    let data: ApplyCookieStateCookie = {
      typeArr: applyCookieTypeArr,
      optCookieListVer
    };
    let dataJson = JSON.stringify(data);

    // applyCookie 쿠키생성
    setCookie(this.APPLY_COOKIE, dataJson, 180, '.plaync.com');

    // 서버에 전송
    cookieLog(dataJson);

    // 저장하지 않은 타입의 First-party 쿠키 삭제
    this.deleteCookies(this.cookieNamesToDelete);

    // 페이지 리로드
    setTimeout(()=>{
      if(targetHref === location.href) {
        location.reload();
      }else{
        location.href = targetHref;
      }
    },0);


    return false;
  }

  // 토스트창 출력해도 되는지 확인
  _chkIsOpenLayer(curOptCookieListVer: string): boolean{
    // 언어가 한국어 일경우 토스트창 출력 안함!
    if(this.isKoreaLanguge()) return false;

    let data = getCookie(this.APPLY_COOKIE);

    // 쿠키허용상태를 저장한 쿠키가 없는경우 & 6개월 초과된 경우(6개월 초과되면 자동으로 쿠키허용상태를 저장한 쿠키가 삭제)
    if(!data) return true;

    try{
      let dataObj: ApplyCookieStateCookie = JSON.parse(window.decodeURIComponent(data)); // setCookie 유틸에서 자동으로 encodeURIComponent 를 실행한다.

      // 기존에 전부 허용이 아니면서 && 쿠키리스트의 갱신이 있었던 경우
      if(!this._isAllCookieApply(dataObj.typeArr) && dataObj.optCookieListVer !== curOptCookieListVer){
        return true;
      }
    }catch(err){
      setCookie(this.APPLY_COOKIE, '', 0, '.plaync.com');

      return true;
    }

    return false;
  }

  // 모든 타입의 쿠키를 허용한 상태인지 확인
  _isAllCookieApply(typeArr: ApplyCookieTypeArr): boolean{
    let applyCookieTypeAll: ApplyCookieTypeAll = ['NECESSARY', 'FUNCTIONAL', 'PERFORMANCE', 'ADVERTISING'];
    return this._isArrHasAllTraget(typeArr, applyCookieTypeAll);
  }

  // (유틸) 어떤 배열에 주어진 값이 전부 있는지 확인
  _isArrHasAllTraget(targetArr: unknown[], searchArr: unknown[]): boolean{
    let result = true;

    searchArr.forEach((search)=>{
      if(!targetArr.includes(search)){
        result = false;
      }
    });

    return result;
  }

  // 브라우저에 저장된 쿠키중에 진짜로 제거되어야 하는 쿠키
  _getNotAppiedCookieNames(AllCookieNamesFromConti:Record< keyof CookieDatas, string[]>, cookieTypeIsBeenApplied: ApplyCookieTypeArr): string[]{
    let appliedCookies: string[] = [];
    let notAppliedCookies: string[] = [];
    let currentBrowserCookieName =  Object.keys(getCookies());

    appliedCookies.push(...AllCookieNamesFromConti.required);
    cookieTypeIsBeenApplied.includes('FUNCTIONAL') && appliedCookies.push(...AllCookieNamesFromConti.optional) || notAppliedCookies.push(...AllCookieNamesFromConti.optional);
    cookieTypeIsBeenApplied.includes('PERFORMANCE') && appliedCookies.push(...AllCookieNamesFromConti.optional2) || notAppliedCookies.push(...AllCookieNamesFromConti.optional2);
    cookieTypeIsBeenApplied.includes('ADVERTISING') && appliedCookies.push(...AllCookieNamesFromConti.optional3) || notAppliedCookies.push(...AllCookieNamesFromConti.optional3);

    appliedCookies = Array.from(new Set(appliedCookies)); // 콘티에서 받은 동의한 쿠키 이름 ( * 표시 포함 )
    notAppliedCookies = Array.from(new Set(notAppliedCookies)); // 콘티에서 받은 비동의한 쿠키 이름 ( * 표시 포함 )

    // console.log('all Conti Cookie name: ', AllCookieNamesFromConti); // 콘티에서 넘어온 모든 쿠키
    // console.log('all appliedCookies: ', appliedCookies);
    // console.log('all notAppliedCookies: ', notAppliedCookies);
    // console.log('all Browser Cookie name: ', currentBrowserCookieName); // 브라우저에 저장된 모든 쿠키

    // 브라우저에 저장된 쿠키 중에 동의 하지 않은 쿠키 (동의하지 않은 쿠키에 대해 * 정규식 적용)
    let targetToDeleteIncludeLive =  Array.from(new Set(this._getSelectCookieIncludedTargets(currentBrowserCookieName, notAppliedCookies)));
    // console.log('targetToDeleteIncludeLive: ', targetToDeleteIncludeLive);

    // 브라우저에 저장된 쿠키 중에 동의 하지 않은 쿠키 중에 포함된 동의 한 쿠키 (동의 하지 않은 쿠기와, 동의한 쿠키에 중복으로 있는 것이 있다.) (동의한 쿠키에 대해 * 정규식 적용)
    let targetToLive = Array.from(new Set(this._getSelectCookieIncludedTargets(targetToDeleteIncludeLive, appliedCookies)));
    // console.log('targetToLive: ', targetToLive);

    // 브라우저에 저장도니 쿠키 중에 동의 하지 않은 쿠키 - 브라우저에 저장된 쿠키 중에 동의 하지 않은 쿠키 중에 포함된 동의 한 쿠키
    let targetToDeleteExceptLive  = this.ArrayToRemoveArray(targetToDeleteIncludeLive, targetToLive);
    // console.log('targetToDeleteExceptLive: ', targetToDeleteExceptLive);

    return targetToDeleteExceptLive;
  }


  // 콘티에서 가져온 선택타입 쿠키 정보
  _getCookieDataOptionals(cookieDataWrap: ContiGroupAPIResponse): ContiContentAPIResponse<'global-cookie-list-optionals'>{
    return  cookieDataWrap.find((e)=>{return e.alias === 'global-cookie-list-optionals';}) as ContiContentAPIResponse<CONTI_ALIAS_GLOBAL_COOKIE_LIST_OPTIONALS>;
  }

  // 콘티에서 가져온 필수타입 쿠키 정보
  _getCookieDataRequired(cookieDataWrap: ContiGroupAPIResponse): ContiContentAPIResponse<'global-cookie-list-required'>{
    return cookieDataWrap.find((e)=>{return e.alias === 'global-cookie-list-required';}) as ContiContentAPIResponse<CONTI_ALIAS_GLOBAL_COOKIE_LIST_REQUIRED>;
  }

  // 콘티에서 가져온 쿠키정보 (이름, 유형...등)
  _getCookeDatas(cookieDataOptionals: ContiContentAPIResponse<'global-cookie-list-optionals'>, cookieDataRequired: ContiContentAPIResponse<'global-cookie-list-required'>):CookieDatas{
  return  Object.assign({},JSON.parse(cookieDataOptionals.jsonData), JSON.parse(cookieDataRequired.jsonData));
  }

  // 현재 언어가 한국어인지 확인
  isKoreaLanguge(): boolean{
    return getLang().toLowerCase() === 'ko';
  }

  // 기존에 동의한 내용이 있는지 확인 (쿠키가 있는지 확인)
  get hasBeenAppliedCookie(): boolean{
    return !!getCookie(this.APPLY_COOKIE);
  }

  // 현재 applyCookie 라는 이름의 쿠키에 저장되어 있는, 유저가 허용한 쿠키 타입 반환
  getHasBeenAppliedCookieTypes(): ApplyCookieTypeArr {
    if(!this.hasBeenAppliedCookie) return [];

    let dataObj: ApplyCookieStateCookie = JSON.parse(window.decodeURIComponent(getCookie(this.APPLY_COOKIE))); // setCookie 유틸에서 자동으로 encodeURIComponent 를 실행한다.

    return dataObj.typeArr;
  }

  get isAppliedNecessaryCookie(): boolean{
    return this.getHasBeenAppliedCookieTypes().includes('NECESSARY');
  }

  get isAppliedFunctionalCookie(): boolean{
    return this.getHasBeenAppliedCookieTypes().includes('FUNCTIONAL');
  }

  get isAppliedPerformanceOrAnalyticalCookie(): boolean{
    return this.getHasBeenAppliedCookieTypes().includes('PERFORMANCE');
  }

  get isAppliedTargetingAdvertisingCookie(): boolean{
    return this.getHasBeenAppliedCookieTypes().includes('ADVERTISING');
  }

  // 콘티에 저장된 쿠키들의 이름 빼오기
  getAllCookieNamesFromConti(cookieDatas: CookieDatas): Record< keyof CookieDatas, string[]>{

    let result: Record< keyof CookieDatas, string[] >= {
      required: [],
      optional: [],
      optional2: [],
      optional3: []
    };

    let key: keyof CookieDatas;

    for (key in cookieDatas){
      let names = cookieDatas[key].reduce((acc, cookieData) => {
        return acc.concat(cookieData.name);
      },<string[]>[]);

      result[key] = (names);
    }

    return result;
  }

  // // 유저가 허용하지 않은 타입의 쿠키 이름 반환
  getCookieNamesToDeleteSuper(cookieDatas: CookieDatas): ReturnType<InstanceType<typeof AbsGlobalCookie>['_getNotAppiedCookieNames']>{
    let AllCookieNamesFromConti = this.getAllCookieNamesFromConti(cookieDatas); // 콘티에서 받은 모든 쿠키 이름
    let cookieTypeIsBeenApplied = this.getHasBeenAppliedCookieTypes(); // 허용한 쿠키 타입
    // if(!target) return false;

    // 유저가 허용하지 않은 타입의 쿠키 이름 반환
    return this._getNotAppiedCookieNames(AllCookieNamesFromConti, cookieTypeIsBeenApplied);
  }

  // 쿠키 지우기
  deleteCookies(targetCookies: string[]): void{
    targetCookies.forEach( (name: string) => {
        document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=plaync.com`; // .plaync.com 를 명시하고 만든 쿠키 && 루트 path에 해당하는 쿠키만 날림 (만들때 도메인을 명시하지 않은 경우라면)
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:01 GMT;`; // 현재의 도메인 && 현재의 path 에 해당 하는 쿠키만 날림 (쿠키 만들때 도메인 지정 안한경우 - 만들 당시의 도메인 = 현재의 도메인)
        document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;`; // 현재의 도메인 && 루트 path 에 해당 하는 쿠키만 날림

        document.cookie = `${name}=; path=/naeu; expires=Thu, 01 Jan 1970 00:00:01 GMT;`; // lineage2m.plaync.com/naeu/를 위한 쿠키날림
        document.cookie = `${name}=; path=/ru ; expires=Thu, 01 Jan 1970 00:00:01 GMT;`; // lineage2m.plaync.com/ru/를 위한 쿠키날림
        // 위 두가지 케이스에 대한 쿠키에 대해서 (/naeu, /ru)
        // IP별로 다르게 동작하는 쿠키가 필요하다고 한다.
        // lineage2m의 경우 ru와 naeu는 모두 다른 IP로 취급한다.
        // 즉, ru와 naeu 각각에서 다르게 동작하는 쿠키를 생성하기 하기 위해서는 path가 /ru/ 이거나 /naeu/ 가 필요하게 된다.

        // 도메인 값을 지정해주지 않은 이유는, /ru 패스의 경우 lineagew 와 같은 글로벌 서비스에는 포함 되어 있기 때문이다.
        // 즉 도메인을 plaync.com 으로 지정하고, /ru 패스를 지정한 쿠키를 생성하고, 나중에 해당 쿠키를 덮어 쓸경우
        // 덮어 쓴다는 의미이가, 여기서 지우는게 아니라, 예를 들면 lineage2m/ru/ 에서 쿠키를 설정 하고, 나중에 lineagw/ru/에서 쿠키를 설정하면,
        // 두 개의 쿠키는 같은 쿠키로 취급되며 충될이 날것이다.
        // 그래서 도메인 값을 지정해주지 않는다.

        // 쿠키 지우기 한계점
        // 1. 기본적으로 쿠키를 만들때 path를 지정하지 않은 쿠키는 지워지지 않는다. (/kr/ 또는 /community_aaaa/list/ 와 같이...)
        // 2. 도메인은 지정하지 않은채 만든 쿠키의 경우(쿠키를 만들 당시의 도메인이 저장되어 있는경우) 다른 도메인에서 이로직이 실행된다고 해서 그 쿠키가 지워지지 않는다.
        // 3. 어떤 페이지든 진입할때 마다 이 로직을 돌리지 않는이상... 다른 plaync 도메인에 있는 모든 쿠키를 지우는 것은 불가능 하다.
        //    => 진입할때 마다 지워주고 있었다. confirmToast.ts 의 init(); 에 this.deleteCookies를 사용하고 있다.
        //    => 즉 다른 plaync 도메인에 진입하면 쿠키가 지워진다. (루트 패스 혹은 진입했을때의 패스에 한정됨 (1)번 한계점은 그대로 남아 있음)

        // 참고
        // 읽을수 있다는 것과 지운다(즉, 덮어쓴다)는 다른 이야기 이다.
        // 만들때 도메인을 eTLD로(예를들면 plaync.com) 지정하고 만들면
        // plaync.com 하위 도메인에서 읽을 수 있다.
        // 단 덮어쓰기 위해서는 만들때와 동일하게 도메인을 eTLD로(예를들면 plaync.com)지정하고 덮어 써야 한다.
        // 하위 도메인에서 읽을 수 있다고, 도메인을 지정하지 않고 덮어쓰면
        // 현재의 도메인을 값으로 가지고 있는 전혀 새로운 쿠키가 생성된다.
    });
  }

  // 주어진 타켓 쿠키 이름에 대해 해당 하는 쿠키 선정
  _getSelectCookieIncludedTargets(browserCoocookieNames: string[], targetCookieNames: string[]): string[]{

    let selectedCookieNames = targetCookieNames.reduce((acc, name)=>{
      let targetArr;

      if(/\*/.test(name)){
        let regex = new RegExp(`^${name.replace('*','.*')}`);
        targetArr = browserCoocookieNames.filter(e => regex.test(e));
      }else{
        targetArr = browserCoocookieNames.filter(e => e === name);
      }

      acc = acc.concat(...targetArr);

      return acc;

    }, <string[]>[]);

    selectedCookieNames = selectedCookieNames.flat(Infinity);
    return selectedCookieNames;
  }

  // 1번 배열에서, 2번 배열에 없는 요소를 제거
  ArrayToRemoveArray(baseArr: string[], targetArr:string[]) :string[]{
    return baseArr.reduce((acc, cur)=>{
      if(!targetArr.includes(cur)) {
        acc = acc.concat(cur);
      }
      return acc;

    },<string[]>[]);
  }
}

